/* global GM_STATE */
import { useEffect, useState } from 'preact/hooks'

const parseSizedUrl = (url) => {
  const match = typeof url === 'string' && url.match(/^(.*)_(\d+)x(\.[^./?]+)(\?.*)?$/)

  if (!match) return null

  const [, base, width, extension, query = ''] = match

  return {
    width: Number(width),
    withWidth: (newWidth) => `${base}_${newWidth}x${extension}${query}`
  }
}

function Image({
  imageUrl = [GM_STATE.shopify.defaultImage],
  alt,
  className,
  imageClass,
  isLazy = true,
  isCover = true,
  imageSrcSet = [],
  imageBreakpoints = '(min-width: 0px)',
  key
}) {
  const [currentImageUrls] = useState(imageUrl)
  const classImage = `${isCover ? 'object-cover' : 'object-contain'} ${isLazy && 'lazyload'} ${imageClass}`
  const customClass = `relative ${className}`
  let fallbackImageUrl = currentImageUrls[0]
  let breakpoints = imageBreakpoints.includes('|') ? imageBreakpoints.split('|') : [imageBreakpoints]

  if (currentImageUrls.length <= 1) {
    breakpoints = breakpoints.splice(0, 1)
  } else {
    breakpoints = breakpoints.splice(0, currentImageUrls.length)
    fallbackImageUrl = currentImageUrls[currentImageUrls.length - 1]
  }

  useEffect(() => {
    if (window.lazySizes) {
      window.lazySizes.init()
    }
  }, [])

  const getSrcSet = (url) => {
    if (imageSrcSet.length === 0) return url

    const sizedUrl = parseSizedUrl(url)

    if (!sizedUrl) return imageSrcSet.map((srcset) => `${url} ${srcset}w `).join(',')

    const widths = imageSrcSet.filter((width) => width <= sizedUrl.width)

    return widths.length > 0
      ? widths.map((width) => `${sizedUrl.withWidth(width)} ${width}w`).join(',')
      : `${url} ${sizedUrl.width}w`
  }

  return (
    <figure className={customClass} key={key}>
      <picture>
        {breakpoints.map((breakpoint, index) => (
          <source
            media={breakpoint}
            srcSet={isLazy ? undefined : getSrcSet(currentImageUrls[index])}
            data-srcset={isLazy ? getSrcSet(currentImageUrls[index]) : undefined}
          />
        ))}
        <img
          src={isLazy ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUCB1j+Pjx438ACX0D04PrXz0AAAAASUVORK5CYII=' : fallbackImageUrl}
          className={classImage}
          data-sizes='auto'
          data-src={isLazy ? fallbackImageUrl : undefined}
          alt={alt}
        />
      </picture>
    </figure>
  )
}

export default Image
